import api from '@/api';
import {
  PaymentFinancialPendingRequest,
  PaymentFinancialPendingResponse,
  PaymentTransactionCancelRequest,
  PaymentTransactionRequest,
} from './transactions.types';

const path = '/payment-gateway/v1/transactions';

export default {
  async create(data: PaymentTransactionRequest) {
    const result = (await api.post(path, data)) as unknown;
    return result as void;
  },

  async status(params: PaymentFinancialPendingRequest) {
    const result = (await api.get(
      `${path}/status/${params.entityType}/${params.entityId}`,
      null,
    )) as unknown;

    return result as PaymentFinancialPendingResponse;
  },

  async transactionCancel({
    transactionId,
    ...data
  }: PaymentTransactionCancelRequest) {
    return api.post(`${path}/${transactionId}/cancel`, data);
  },
};
